import { createFeatureSelector, createSelector } from '@ngrx/store';

import { safeSelect, StateSelector } from '@fcom/core/selectors/selector-utils';
import { Company } from '@fcom/common/interfaces';

import { CORPORATE_FEATURE_KEY, CorporateFeatureState, CorporateState } from '../constants';

export const _corporateState = createFeatureSelector<CorporateState>(CORPORATE_FEATURE_KEY);
export const _company = createSelector(_corporateState, (state: CorporateState) => state.company?.companyDetails);

export const company = (): StateSelector<CorporateFeatureState, Company> => safeSelect(_company);
